import {FormSection} from "base/component/form";

const EntityFormCaracteristicasSection = ({title = "Características", fields}) => {
    return (
        <>
            <FormSection title={title}>{fields}</FormSection>
        </>
    );
};

export default EntityFormCaracteristicasSection;
